import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { ItemPropertyValue } from "./ItemPropertyValue";
import { ItemPropertyImage } from "./ItemPropertyImage";
import { ItemPropertyLocation } from "./ItemPropertyLocation";
import EditIcon from '@mui/icons-material/EditOutlined';
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { EnumArrayProperty } from "./items/EnumArrayProperty";
import { DateProperty } from "./items/DateProperty";
import { StatusBadge } from "./ui/ItemCard";
import { formatLabel } from "../utils/itemUtil";

const WIDE_TYPES = ['location', 'image'];

// Link to propose an edit, or to the pending update for this property.
export const PropertyEditButton = ({ itemId, propertyName, itemUpdates = [] }) => {
    const user = useSelector(state => state.login.user);
    if (!user) return null;
    const update = itemUpdates.find(iu => iu.property === propertyName);
    const editLink = update ? `/item-update/${update.id}` : `/create-item-update/${itemId}/${propertyName}`;
    const label = update ? `View pending update to ${formatLabel(propertyName)}` : `Suggest an edit to ${formatLabel(propertyName)}`;
    return (
        <Tooltip title={label}>
            <IconButton component={RouterLink} to={editLink} size="small" aria-label={label} sx={{ color: 'text.secondary' }}>
                <EditIcon sx={{ fontSize: 16 }} />
            </IconButton>
        </Tooltip>
    );
}

// Renders one schema-driven property as a dt/dd pair inside a <dl>.
export const ItemProperty = ({ itemId, dataInfo, data, itemUpdates = [] }) => {

    const value = data[dataInfo.name];
    const type = {
        'location': <ItemPropertyLocation coords={value} />,
        'image': <ItemPropertyImage image={value} />,
        'array_enum': <EnumArrayProperty value={value} />,
        'date': value ? <DateProperty value={value} /> : <ItemPropertyValue value={value} />,
    }
    const update = itemUpdates.find(iu => iu.property === dataInfo.name);

    return (
        <Box sx={{ gridColumn: WIDE_TYPES.includes(dataInfo.type) ? '1 / -1' : 'auto', minWidth: 0 }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px', minHeight: 30 }}>
                <Typography component="dt" variant="caption" color="text.secondary">{formatLabel(dataInfo.name)}</Typography>
                {update ? <StatusBadge sx={{ fontSize: '0.6875rem', py: 0 }}>Update pending</StatusBadge> : null}
                <PropertyEditButton itemId={itemId} propertyName={dataInfo.name} itemUpdates={itemUpdates} />
            </Box>
            <Box component="dd" sx={{ m: 0, fontSize: '0.875rem', overflowWrap: 'anywhere' }}>
                {type[dataInfo.type] || <ItemPropertyValue value={value} />}
            </Box>
        </Box>
    );
}
